<div class="layout-topbar">
    <div class="layout-topbar-brand">
        <a class="layout-topbar-logo" routerLink="/dashboard/admindashboard" aria-label="LMS admin dashboard">
            <img src="../../assets/layout/images/PSHealth_logo.png" alt="Primary and Secondary Healthcare Department">
        </a>

        <button #menubutton class="p-link layout-menu-button layout-topbar-button" type="button"
            aria-label="Toggle navigation" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
    </div>

    <div class="layout-topbar-title">
        <h1>Learning Management System</h1>
    </div>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <div class="topbar-context">
            <span class="topbar-context__icon"><i class="pi pi-shield"></i></span>
            <span class="topbar-context__copy">
                <strong [title]="userFullName">{{ userFullName }}</strong>
                <small>Admin Portal</small>
            </span>
        </div>
        <button class="p-link layout-topbar-button topbar-logout" type="button" (click)="logout()">
            <i class="pi pi-power-off"></i>
            <span>Logout</span>
        </button>
    </div>
</div>
